import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import moment from 'moment';
import { stringify } from 'qs';

import { WorkOrder } from '../models';

import { environment } from '@vandelft/environments/environment';
import { transformModel } from '../rxjs/operators/transform-model';

interface WorkOrderFilters {
  end?: string;
  isPaid?: boolean;
  mechanicId?: string;
  paymentMethod?: string;
  sortDirection?: string;
  start?: string;
  state?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WorkOrdersService {
  public constructor(private http: HttpClient) {}

  public getQueryString(options?: WorkOrderFilters): string {
    const defaultOptions = {
      end: null,
      isPaid: null,
      mechanicId: null,
      paymentMethod: null,
      sortDirection: 'asc',
      start: null,
    };

    const mergedOptions = { ...defaultOptions, ...options };

    if (mergedOptions.start !== null && mergedOptions.start.length > 0) {
      mergedOptions.start = moment(mergedOptions.start).toDate();
    }

    if (mergedOptions.end !== null && mergedOptions.end.length > 0) {
      mergedOptions.end = moment(mergedOptions.end).toDate();
    }

    for (const key of Object.keys(mergedOptions)) {
      const value = mergedOptions[key];
      if (!value) {
        delete mergedOptions[key];
      }
    }

    return stringify(mergedOptions);
  }

  public getWorkOrders(options?: WorkOrderFilters): Observable<any> {
    const queryString = this.getQueryString(options);
    return this.http.get(`${environment.apiUrl}/work-orders?${queryString}`).pipe(transformModel<WorkOrder>(WorkOrder));
  }

  public getWorkOrderById(id: string): Observable<WorkOrder> {
    return this.http.get(`${environment.apiUrl}/work-orders/${id}`).pipe(transformModel<WorkOrder>(WorkOrder));
  }
}
